import React from 'react';
import { Helmet } from 'react-helmet';
import FAQ, { faqs } from '@/components/FAQ';

const FAQPage = () => {
  const canonical = 'https://phantompathvpn.com/faq';
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <>
      <Helmet>
        <title>Frequently Asked Questions | PhantomPathVPN</title>
        <meta name="description" content="Answers about PhantomPath VPN accounts, access codes, prices, devices, payments, refunds, privacy logs, eSIM data and virtual numbers." />
        <link rel="canonical" href={canonical} />
        <meta property="og:url" content={canonical} />
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      </Helmet>
      <main className="min-h-screen bg-[#0a0a0a] pt-8">
        <FAQ standalone />
      </main>
    </>
  );
};

export default FAQPage;
